import React from 'react';
import { useInvestorMe } from '../../hooks/useInvestorMe';
import QuixInfo from '../shared/QuixInfo';

export default function InvestorHome() {
  const { me, loading, error } = useInvestorMe({ enforceNda: true });

  return (
    <div>
      <div className="banner" style={{ marginBottom: 16 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', gap: 12, flexWrap: 'wrap', alignItems: 'center' }}>
          <div>
            <div style={{ fontWeight: 900, marginBottom: 4 }}>Welcome{me?.person?.name ? `, ${me.person.name}` : ''}</div>
            {loading ? <div className="muted">Loading access…</div> : null}
            {error ? <div className="muted">We couldn't validate your access. Please reopen your personal link.</div> : null}
            {!loading && !error ? <div className="muted">Your access is personal and logged (logins, pages visited, and downloads).</div> : null}
          </div>
          {!loading && !error ? <div className="pill">Read-only access</div> : null}
        </div>
      </div>
      <QuixInfo exportedByName={me?.person?.name} />
    </div>
  );
}
